import React from 'react'
import { Button, Icon } from '@equinor/eds-core-react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

interface IDetailsButton {
    sensorTag?: string | null
    onClick?: () => void
}

const DetailsButton: React.FC<IDetailsButton> = ({ sensorTag, onClick }) => {
    const navigate = useNavigate()

    const handleClick = () => {
        onClick?.()
        navigate(`/dashboard/${sensorTag}`)
    }

    return (
        <StyledDetailsButton variant="ghost" onClick={handleClick}>
            Details<Icon name="go_to"></Icon>
        </StyledDetailsButton>
    )
}

const StyledDetailsButton = styled(Button)`
    height: 36px;
    width: 100px;
    display: flex;
    gap: 7px;
    font-family: Equinor;
    font-size: 14px;
    color: #007079;
    align-items: center;
    justify-content: center;
    border: none;

    &:hover {
        border: none;
        color: #006269ff;
        background: #ddececff;
        border-radius: 4px;
    }
`

export default DetailsButton
